import React from 'react'
import { Input } from '@wework/dieter-ui'

class SearchBox extends React.PureComponent {
  state = {}

  render() {
    const { onChange, searchText, disabled, placeholder } = this.props

    return (
      <Input
        {...this.props}
        icon="search"
        iconPosition="left"
        type="Search"
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        value={searchText === undefined ? '' : searchText}
      />
      // <TextField
      //   autoComplete="off"
      //   onChange={onChange}
      //   id="input-with-icon-textfield"
      //   value={searchText === undefined ? '' : searchText}
      //   disabled={disabled}
      //   InputProps={{
      //     startAdornment: (
      //       <InputAdornment position="start">
      //         <Search />
      //       </InputAdornment>
      //     ),
      //   }}
      //   type="Search"
      // />
    )
  }
}

export default SearchBox
